import { put, fork, call, takeEvery, all } from 'redux-saga/effects';
import app from '../../app';
import { loadHelpListCompletion, loadHelpCompletion } from '../../actions';

export function* watchLoadHelpList() {
  yield takeEvery('LOAD_HELP_LIST', function*() {
    const options = {
      url: `/sfapi/helpArticle/list`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadHelpListCompletion(result.error, result.data));
  });
}

export function* watchLoadHelp() {
  yield takeEvery('LOAD_HELP', function*({ aid }) {
    const options = {
      url: `/sfapi/helpArticle/${aid}/detail`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadHelpCompletion(aid, result.error, result.data));
  });
}

export default function* helpSaga() {
  yield all([fork(watchLoadHelpList), fork(watchLoadHelp)]);
}
